<template>
  <component
    :is="componentTag"
    v-if="brand.logo"
    v-bind="componentProperties"
  >
    <BrandImage
      :brand="brand"
      :size="size"
    />
  </component>
</template>

<script lang="ts">

import { LINK_TYPE } from '~~/types/components/Link/LinkType';
import type { BrandInfo } from '~~/constants/brands';
import { ALLOWED_SIZES, type BrandImageSize } from '~/components/molecules/Product/Brand/BrandImage/BrandImage.vue';

export default defineComponent({
  name: 'BrandImageLink',

  props: {
    brand: {
      type: Object as PropType<BrandInfo>,
      required: true,
    },
    size: {
      type: String as PropType<BrandImageSize>,
      default: ALLOWED_SIZES.SMALL,
      validator: (value: unknown): boolean => {

        return Object.values(ALLOWED_SIZES).includes(value as BrandImageSize);
      
      },
    },
  },
  setup(props) {

    const { getBrandInternalPageUrl } = useBrandPage();
    const brandPage = computed(() => getBrandInternalPageUrl(props.brand));
    const componentTag = computed(() => brandPage.value ? resolveComponent('CustomLink') : 'div');
    const componentProperties = computed(() => brandPage.value ? {
      url: brandPage.value,
      type: LINK_TYPE.NoStyle,
    } : {});

    return {
      componentTag,
      componentProperties,
    };
  
  },
});

</script>
